import React from 'react';
import { FileUpload as NewFileUpload } from './FileUpload';
import { convertOldFileUploadProps } from './converter.old';
import type { OldFileUploadProps } from './converter.old';
export type FileUploadProps = OldFileUploadProps;
export const FileUpload = (props: FileUploadProps) => <NewFileUpload {...convertOldFileUploadProps(props)} />;
